import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-audit-delete-task',
  templateUrl: './common-audit-delete-task.component.html',
  styleUrls: ['./common-audit-delete-task.component.css']
})
export class CommonAuditDeleteTaskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
